import { render, staticRenderFns } from "./InsumoNoUso.vue?vue&type=template&id=55009b44"
import script from "./InsumoNoUso.vue?vue&type=script&lang=js"
export * from "./InsumoNoUso.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports